import React from 'react';
import PropTypes from 'prop-types';

import './graph.scss';
import GenericCategoryGraph, { chartTypeEnum } from './GenericCategoryGraph';

export default function CptCodesDistributionGraph(props) {
  const { graphData, colorPalette, graphType, tooltipTitle } = props;
  const dataSeries = [
    {
      name: 'Number of Codes',
      color: colorPalette?.interpolate(0.73),
      selector: item => item.count,
    },
  ];
  return graphType === "numbers" ? (
    <div className="box2colsWithVl vncols">
      {graphData &&
        graphData.map(v => (
          <div className="box2colsWithVl-box" key={v.codes}>
            <div className="box2colsWithVl-valueBox black">
              {v.count}
            </div>
            <div className="box2colsWithVl-labelBox">
              {v.codes}
            </div>
          </div>
        ))}
    </div>
  ) : (
    <GenericCategoryGraph
      graphData={graphData}
      hasBorder
      forceCondensed
      xAxisTopPosition={false}
      yAxisWidth={graphType === chartTypeEnum.horizontalBar ? 120 : 40}
      yAxisUnit=""
      tooltipTitle={tooltipTitle || 'Cpt Codes Distribution'}
      dataSeries={dataSeries}
      categorySelector={item => item.codes}
      hasReferenceAreas
      graphType={graphType}
      colorPalette={colorPalette}
    />
  );
}

CptCodesDistributionGraph.propTypes = { graphData: PropTypes.array };
